var render, staticRenderFns
import script from "./RodeAccordionComponent.vue?vue&type=script&lang=js&"
export * from "./RodeAccordionComponent.vue?vue&type=script&lang=js&"
import style0 from "./RodeAccordionComponent.vue?vue&type=style&index=0&id=f117ab0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f117ab0a",
  null
  
)

export default component.exports